<template>
    <div class="modal-overlay" @click="closeMenuModal">
        <div class="modal" @click.stop>
            <button class="modal-close" @click="closeMenuModal">×</button>
            <h3>{{ mode == 'add' ? '메뉴 추가' : '메뉴 수정' }}</h3>
            <form @submit.prevent="handleSubmit">
                <div>
                    <label>메뉴명</label>
                    <input type="text" v-model="formData.menuName" required placeholder="메뉴명을 입력하세요" maxlength="30">
                </div>
                <div>
                    <label>메뉴 URL</label>
                    <input type="text" v-model="formData.menuUrl" placeholder="메뉴 URL을 입력하세요" maxlength="255">
                </div>
                <div>
                    <label>사용여부</label>
                    <div style="display: flex; gap: 20px; margin-top: 8px;">
                        <label style="display: flex; align-items: center; font-weight: normal; cursor: pointer;">
                            <input type="radio" v-model="formData.useYn" value="Y" style="margin-right: 6px;">
                            사용
                        </label>
                        <label style="display: flex; align-items: center; font-weight: normal; cursor: pointer;">
                            <input type="radio" v-model="formData.useYn" value="N" style="margin-right: 6px;">
                            미사용
                        </label>
                    </div>
                </div>
                <div class="modal-form-buttons">
                    <button type="button" @click="closeMenuModal">취소</button>
                    <button type="submit">{{ mode == 'add' ? '추가' : '수정' }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import api, {urls} from '@/api'
import { useModal } from '@/composables/useModal'
import { ref, reactive, onMounted } from 'vue'


const { closeModal, getModalData, emitModalEvent } = useModal()
const orgData = ref([])

const modalName = 'menuModal'
const menuData = ref([])
const mode = ref('add')
const selectedMenu = ref(null)
const formData = reactive({
    parentId: 0,
    menuName: '',
    menuUrl: '',
    sortOrd: 1,
    useYn: 'Y',
})

// 폼 제출
const handleSubmit = () => {
    if (mode.value == 'add') { 
        // 삽입
        if(selectedMenu.value == null){
            formData.sortOrd = menuData.value.filter(item => item.depth == 1).length + 1
        }else{
            formData.sortOrd = orgData.value.filter(item => item.parent_id == selectedMenu.value.menu_id).length + 1
            formData.parentId = selectedMenu.value.menu_id 
        }
        
        api.post(urls.menu.insert, {
            ...formData
        }).then(res => {
            if(res.data.result == 'success'){
                alert('메뉴가 추가되었습니다.')
            }else{
                alert('오류가 발생하였습니다.')
            }
            closeMenuModal()
            emitModalEvent(modalName, 'onSubmit')
        })
    } else { 
        formData.menuId = selectedMenu.value.menu_id
        // 수정
        api.post(urls.menu.update, {
            ...formData
        }).then(res => {
            if(res.data.result == 'success'){
                alert('메뉴가 수정되었습니다.')
            }else{
                alert('오류가 발생하였습니다.')
            }
            closeMenuModal()
            emitModalEvent(modalName, 'onSubmit')
        })
    }
}

const closeMenuModal = () => {
    selectedMenu.value = null
    resetForm()
    closeModal()
}

// form reset
const resetForm = () => {
    formData.parentId = 0
    formData.menuName = ''
    formData.menuUrl = ''
    formData.sortOrd = 1
    formData.useYn = 'Y'
}

onMounted(() => {
    const data = getModalData(modalName)
    mode.value = data.mode
    selectedMenu.value = data.selectedMenu
    menuData.value = data.menuData
    if (mode.value == 'edit') {
        formData.parentId = selectedMenu.value.parent_id
        formData.menuName = selectedMenu.value.menu_name
        formData.menuUrl = selectedMenu.value.menu_url
        formData.sortOrd = selectedMenu.value.sort_ord
        formData.useYn = selectedMenu.value.use_yn
    }
})
</script>
